import { observer } from 'mobx-react';
import { FormFieldLine } from '../../../../../../components/form-field-line/form-field-line';
import { Input } from '../../../../../../components/inputs/input/input';
import { IValidationGroup } from '../../../../../../hooks/validation-group/validation-group-hook';
import RlmCredentialsStore from "../../../stores/credentials/rlm-credentials-store";

interface IIntegrationProps {
    credentialsStore: RlmCredentialsStore,
    vGroup: IValidationGroup,
}

const RlmCredentials: React.FC<IIntegrationProps> = observer(({credentialsStore, vGroup}) => {
    return (
        <>
            <FormFieldLine label='RLM Username' required key='username'>
                <Input
                    value={credentialsStore.username}
                    onChange={v => credentialsStore.username = v}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
            <FormFieldLine label='RLM Key' required key='key'>
                <Input
                    value={credentialsStore.key                }
                    onChange={v => credentialsStore.key = v}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
            <FormFieldLine label='RLM Customer Code' required key='customer_code'>
                <Input
                    value={credentialsStore.customer_code}
                    onChange={v => credentialsStore.customer_code = v}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
            <FormFieldLine label='RLM Store Number' key='store_number'>
                <Input
                    value={credentialsStore.store_number}
                    onChange={v => credentialsStore.store_number = v}
                    validationGroup={vGroup}
                />
            </FormFieldLine>
            <FormFieldLine label='RLM URL Prefix' key='url_prefix'>
                <Input
                    value={credentialsStore.url_prefix}
                    onChange={v => credentialsStore.url_prefix = v}
                    validationGroup={vGroup}
                />
            </FormFieldLine>
        </>
    )
});

export default RlmCredentials;
